import config from '../assets/iconsNavBar/config.svg';
import link from '../assets/iconsNavBar/link.svg';
import mapaLoja from '../assets/iconsNavBar/mapaLoja.svg';
import personalizarApp from '../assets/iconsNavBar/personalizarApp.svg';
import push from '../assets/iconsNavBar/push.svg';
import user from '../assets/images/user.svg';
import menu from '../assets/images/menu.svg';
import file from '../assets/images/file.svg';
import showcase from '../assets/images/showcase.svg';
import coin from '../assets/images/coin.svg';
import shieldCheck from '../assets/images/ShieldCheck.svg';
import phone from '../assets/images/Phone.svg';
import resultados from '../assets/iconsNavBar/resultados.svg';
import lookbook from '../assets/iconsNavBar/lookbook.svg';
import check from '../assets/images/check.svg';
import loginImage from '../assets/images/loginImage.svg';
import priceTag from '../assets/images/priceTag.svg';
import screens from '../assets/images/telas_celulares.svg';
import contact from '../assets/images/contact.svg';
import logoMarcaNegativa from '../assets/logos/logoMarcaNegativa.png';
import logoMarcaNegativaOriginal from '../assets/logos/logoMarcaNegativaOriginal.png';
import logoMarcaOriginal from '../assets/logos/logoMarcaOriginal.png';
import logoMarcaPreta from '../assets/logos/mondelezLogoPreta.svg';
import logoNegativa from '../assets/logos/logoNegativa.png';
import logoOriginal from '../assets/logos/logoOriginal.png';
import logoOriginalNegativa from '../assets/logos/logoOriginalNegativa.png';
import logoPreta from '../assets/logos/mondelezLogoPreta.svg';
// import slogan from '../assets/logos/slogan.png';
import sloganPreto from '../assets/logos/sloganPreto.png';
import sloganOriginal from '../assets/logos/sloganOriginal.png';
import sloganNegativaOriginal from '../assets/logos/sloganNegativaOriginal.png';
import rollScreem from '../assets/images/rollScreem.svg';
import totalCaptado from '../assets/images/totalCaptado.svg';
import wallet from '../assets/images/carteira.svg';
import conversion from '../assets/images/conversao.svg';
import activeUsers from '../assets/images/usuariosAtivos.svg';
import salesAmount from '../assets/images/totalDeVendas.svg';
import moreClicks from '../assets/images/moreClicks.svg';
import carrinho from '../assets/images/carrinho.svg';
import listGrid from '../assets/images/listGrid.svg';
import iosWallpaper from '../assets/images/iosWallpaper.jpg';
import androidWallpaper from '../assets/images/androidWallpaper.jpg';
import genericImage from '../assets/images/genericImage.jpg';
import banner12PlaceHolder from '../assets/images/home/banner1-2PlaceHolder.png';
import banner21PlaceHolder from '../assets/images/home/banner2-1PlaceHolder.png';
import banner33PlaceHolder from '../assets/images/home/banner3-3PlaceHolder.png';
import banner4060PlaceHolder from '../assets/images/home/banner40-60PlaceHolder.png';
import banner5050PlaceHolder from '../assets/images/home/banner50-50PlaceHolder.png';
import banner6040PlaceHolder from '../assets/images/home/banner60-40PlaceHolder.png';
import brandCarouselPlaceHolder from '../assets/images/home/brandCarouselPlaceHolder.png';
import carrosselBannersPlaceHolder from '../assets/images/home/carrosselBannersPlaceHolder.png';
import fixedBannerPlaceHolder from '../assets/images/home/fixedBannerPlaceHolder.png';
import modvideoExample from '../assets/images/home/modvideoExample.png';
import placeholderStamplist from '../assets/images/home/placeholder_stamplist.png';
import plcaceholderCarrosselCategorias from '../assets/images/home/plcaceholder_carrossel_categorias.png';
import plcaceholderCarrosselProdutos from '../assets/images/home/plcaceholder_carrossel_produtos.png';
import plcaceholderGridProdutos2 from '../assets/images/home/plcaceholder_grid_produtos_2.png';
import plcaceholderLinkCategorias from '../assets/images/home/plcaceholder_link_categorias.png';
import banner2por2 from '../assets/images/homeTypeBanners/banner2por2.png';
import banner3por3 from '../assets/images/homeTypeBanners/banner3por3.png';
import BannerDuploAssimetricoADireita from '../assets/images/homeTypeBanners/BannerDuploAssimetricoADireita.png';
import BannerDuploAssimetricoAesquerda from '../assets/images/homeTypeBanners/BannerDuploAssimetricoAesquerda.png';
import bannerIndividual from '../assets/images/homeTypeBanners/bannerIndividual.png';
import bannerQuatro from '../assets/images/homeTypeBanners/bannerQuatro.png';
import BannerTriploAssimetricoAdireito from '../assets/images/homeTypeBanners/BannerTriploAssimetricoAdireito.png';
import BannerTriploAssimetricoAEsquerda from '../assets/images/homeTypeBanners/BannerTriploAssimetricoAEsquerda.png';
import signature from '../assets/images/pdp/assinatura.png';
import ratings from '../assets/images/pdp/avaliacoes.png';
import cep from '../assets/images/pdp/campoCep.png';
import carouselProducts from '../assets/images/pdp/carrosselDeProduto.png';
import description from '../assets/images/pdp/descricao.png';
import specification from '../assets/images/pdp/especificacoes.png';
import pickInStore from '../assets/images/pdp/retiradaEmLoja.png';
import sizebay from '../assets/images/pdp/sizebay.png';
import productVariation from '../assets/images/pdp/variacaoDoProduto.png';
import infinetShowcase from '../assets/images/pdp/vitrineInfinita.png';
import gift from '../assets/images/pdp/gift.png';
import note from '../assets/images/pdp/lembrete.png';
import noImg from '../assets/images/noImg.jpg';
import banneDuploVertical from '../assets/images/GridTypes/banneDuploVertical.svg';
import bannerDuplo from '../assets/images/GridTypes/bannerDuplo.svg';
import bannerMosaico from '../assets/images/GridTypes/bannerMosaico.svg';
import bannerMosaicoTriplo from '../assets/images/GridTypes/bannerMosaicoTriplo.svg';
import bannerTriplo from '../assets/images/GridTypes/bannerTriplo.svg';
import BannerTriploaDireita from '../assets/images/GridTypes/BannerTriploaDireita.svg';
import BannerTriploaEsquerda from '../assets/images/GridTypes/BannerTriploaEsquerda.svg';

export const pdpImages = {
	signature,
	ratings,
	cep,
	carouselProducts,
	description,
	specification,
	pickInStore,
	sizebay,
	productVariation,
	infinetShowcase,
	gift,
	note
};

export const svg = {
	check: check,
	loginBackground: loginImage,
	rollScreem: rollScreem,
	totalRaised: totalCaptado,
	wallet: wallet,
	conversion: conversion,
	activeUsers: activeUsers,
	salesAmount: salesAmount,
	moreClicks: moreClicks,
	carrinho: carrinho,
	listGrid: listGrid,
	user: user,
	menu: menu,
	file: file,
	showcase: showcase,
	coin: coin,
	shieldCheck: shieldCheck,
	phone: phone,
	priceTag: priceTag,
	screens: screens,
	contact: contact
};

export const png = {
	logoMarcaNegativa: logoMarcaNegativa,
	logoMarcaNegativaOriginal: logoMarcaNegativaOriginal,
	logoMarcaOriginal: logoMarcaOriginal,
	logoMarcaPreta: logoMarcaPreta,
	logoNegativa: logoNegativa,
	logoOriginal: logoOriginal,
	logoOriginalNegativa: logoOriginalNegativa,
	logoPreta: logoPreta,
	// slogan: slogan,
	sloganPreto: sloganPreto,
	sloganOriginal: sloganOriginal,
	sloganNegativaOriginal: sloganNegativaOriginal,
	iosWallpaper: iosWallpaper,
	androidWallpaper: androidWallpaper,
	genericImage: genericImage,
	noImg
};

export const homeImages = {
	banner12PlaceHolder,
	banner21PlaceHolder,
	banner33PlaceHolder,
	banner4060PlaceHolder,
	banner5050PlaceHolder,
	banner6040PlaceHolder,
	brandCarouselPlaceHolder,
	carrosselBannersPlaceHolder,
	fixedBannerPlaceHolder,
	modvideoExample,
	placeholderStamplist,
	plcaceholderCarrosselCategorias,
	plcaceholderCarrosselProdutos,
	plcaceholderGridProdutos2,
	plcaceholderLinkCategorias,
	banner2por2,
	banner3por3,
	BannerDuploAssimetricoADireita,
	BannerDuploAssimetricoAesquerda,
	bannerIndividual,
	bannerQuatro,
	BannerTriploAssimetricoAdireito,
	BannerTriploAssimetricoAEsquerda
};

export const typesGridBanner = {
	banneDuploVertical,
	BannerTriploaEsquerda,
	BannerTriploaDireita,
	bannerTriplo,
	bannerMosaicoTriplo,
	bannerMosaico,
	bannerDuplo
};

export const navBarImages = {
	config: config,
	link: link,
	storeMap: mapaLoja,
	customizeApp: personalizarApp,
	push: push,
	results: resultados,
	lookbook: lookbook
};

export const noImage = fixedBannerPlaceHolder;
